/** Liste enrichie des maisons (derrière la tuile "Nos maisons"). */
import { Link } from '../lib/router';
import { useI18n } from '../i18n';
import { PageHeader } from '../components/PageHeader';
import { BocuseImage } from '../components/BocuseImage';
import { useMaisons } from '../lib/useMaisons';
import type { Merchant } from '@alterrego/module-merchants-directory';
import './MaisonsScreen.css';

function MaisonCard({ m }: { m: Merchant }) {
  const sub = [m.address?.city, m.activity].filter(Boolean).join(' · ');
  const tag = m.activity || m.category;
  const img = m.cover || m.logo || m.photos?.[0];
  return (
    <Link to={`/maisons/${encodeURIComponent(m.id)}`} className="mb-mcard">
      <BocuseImage src={img} name={m.name} className="mb-mcard-media" />
      <span className="mb-mcard-gradient" aria-hidden="true" />
      {tag && <span className="mb-mcard-tag">{tag}</span>}
      <span className="mb-mcard-body">
        <span className="mb-mcard-name">{m.name}</span>
        {sub && <span className="mb-mcard-sub">{sub}</span>}
      </span>
    </Link>
  );
}

export function MaisonsScreen() {
  const { t } = useI18n();
  const { maisons, loading, error } = useMaisons();

  return (
    <div className="mb-maisons-page">
      <PageHeader title={t('maisons_title')} />
      <main className="mb-maisons-main">
        <p className="mb-maisons-intro">{t('maisons_intro')}</p>
        {loading ? (
          <p className="mb-state">{t('maisons_loading')}</p>
        ) : error ? (
          <p className="mb-state mb-state-error">{t('maisons_error')}</p>
        ) : maisons.length === 0 ? (
          <p className="mb-state">{t('maisons_empty')}</p>
        ) : (
          <div className="mb-mgrid">
            {maisons.map((m) => (
              <MaisonCard key={m.id} m={m} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
